import { IChecklistItemRow } from "@mctypes/checklist.types";
import { Card, Title } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import React, { useEffect } from "react";
import { FailedAlert } from "../../../../../components";
import { ConnectedIssues } from "../../../../../components/ConnectedIssues/ConnectedIssues";
import CreateItemWithBoardSelectorModal from "../../../../../components/CreateItemWithBoardSelectorModal/CreateItemWithBoardSelectorModal";
import FoldableSection from "../../../../../components/FoldableSection/FoldableSection";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { MCApplicationsUrlEnum } from "../../../../../mc-shared/sharedConstants";
import ConnectExistingIssueToItemModalWrapper from "../../../../ConnectExistingIssueToItemModalWrapper";
import { useGetIssueBoardsQuery } from "../../../issuesApp/IssueBoardRTK";
import {
  connectOrDisconnectIssueFromChecklistItemThunk,
  createIssueOnChecklistItemThunk,
  fetchSingleChecklistItemAndReplaceInReduxThunk,
} from "../../checklistSlice";

const ChecklistConnecetedIssues: React.FC<{ checklistRow: IChecklistItemRow; projectId: string }> = ({
  checklistRow,
  projectId,
}) => {
  const [newIssueModalOpen, setNewIssueModalOpen] = React.useState<boolean>(false);
  const [connectExistingModalOpen, setConnectExistingModalOpen] = React.useState<boolean>(false);
  const [wasStarted, setWasStarted] = React.useState<boolean>(false);

  const dispatch = useAppDispatch();

  const openedAppModals = useAppSelector((state) => state.globalReducer.openedAppModals);

  useEffect(() => {
    if (wasStarted === true && openedAppModals.length === 0) {
      // an issue modal was closed. Update table
      dispatch(fetchSingleChecklistItemAndReplaceInReduxThunk(checklistRow._id));
    }
    setWasStarted(true);
  }, [openedAppModals?.length]);

  const onConnect = (issueId: string) => {
    dispatch(connectOrDisconnectIssueFromChecklistItemThunk(checklistRow._id, issueId, "CONNECT"));
    setConnectExistingModalOpen(false);
  };

  const { data: issueBoards = [], error: boardFetchError } = useGetIssueBoardsQuery({
    projectId: projectId,
  });

  const onCreateIssue = (boardId: string) => {
    dispatch(createIssueOnChecklistItemThunk(boardId, checklistRow._id));
    setNewIssueModalOpen(false);
  };

  const apps = useAppSelector((state) => state.globalReducer.apps);

  return (
    <FoldableSection storageKey="checklist-modal-connected-issues">
      <FoldableSection.Header>
        <Title order={6}>Tilknyttede saker</Title>
      </FoldableSection.Header>
      <FoldableSection.Body>
        <Card w="100%" bg="#f8f9fa" bd="1px solid var(--mantine-color-warmgray-2)">
          {boardFetchError && <FailedAlert />}
          <CreateItemWithBoardSelectorModal
            boards={(issueBoards || []).map((board) => {
              return {
                project: board.project,
                name: board.name,
                _id: board._id,
                status: board.status,
              };
            })}
            onCreate={onCreateIssue}
            modalTitle="Koble sak til sjekklistepunkt"
            opened={newIssueModalOpen}
            onClose={() => setNewIssueModalOpen(false)}
            currentApp={MCApplicationsUrlEnum.ISSUE}
            apps={apps}
            projectId={projectId}
            createButtonText="Opprett sak"
          />
          <ConnectExistingIssueToItemModalWrapper
            opened={connectExistingModalOpen}
            onConnected={(boardId, issueId) => onConnect(issueId)}
            projectId={projectId}
            closeModal={() => setConnectExistingModalOpen(false)}
            blockedIssueIds={(checklistRow.connectedIssues || []).map((issue) => issue._id)}
          />
          <ConnectedIssues
            issues={checklistRow.connectedIssues as IIssueApi[]}
            onDisconnectIssue={(issueId) =>
              dispatch(connectOrDisconnectIssueFromChecklistItemThunk(checklistRow._id, issueId, "DISCONNECT"))
            }
            onConnectExistingIssue={() => setConnectExistingModalOpen(true)}
            onCreateNewIssue={() => setNewIssueModalOpen(true)}
            isPrintMode={false}
            disableCellEdit={true}
            titleLabel=""
            projectId={projectId}
          />
        </Card>
      </FoldableSection.Body>
    </FoldableSection>
  );
};

export default ChecklistConnecetedIssues;
